import { Trpconsignment } from './Trpconsignment';
import { TrpmstbillDetail } from './TrpmstbillDetail';
import { Trpmstbill } from './Trpmstbill';

export class GRBill {
    public TRPBILL: Trpmstbill | undefined;
    public TRPBILLDETAILList: TrpmstbillDetail[] = [];
    public TRPCONSIGNMENTList: Trpconsignment[] = [];
}